import React from 'react';
import type { Category } from '@/types';
import GridTile from './GridTile';
import { GRID_GAP } from './MasonryGrid';

interface CategoryGridProps {
  categories: Category[];
  onCategoryClick?: (slug: string) => void;
}

export default function CategoryGrid({
  categories,
  onCategoryClick,
}: CategoryGridProps) {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {categories.map((category) => (
          <GridTile
            key={category.id}
            id={category.slug}
            imageUrl={category.imageUrl}
            imageAlt={category.name}
            title={category.name}
            size={category.gridSize}
            onCardClick={() => onCategoryClick?.(category.slug)}
            showFavoriteButton={false}
          />
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
  } as React.CSSProperties,

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: `${GRID_GAP}px`,
    gridAutoRows: 'auto',
  } as React.CSSProperties,
};
